import React, { useEffect, useContext, useState } from "react";

import { ReactComponent as Navigation } from "../../assets/navigation.svg";
import { ReactComponent as NotificationsBellIcon } from "../../assets/notifications-bell.svg";

import { ContextNotificacoes } from "../../services/notificacoes";

import "./styles.scss";

const NotificationsBell = ({
  primaryColor,
  notificationsModal,
  setNotificationsModal,
}) => {
  const {
    loadNotificacoes,
    marcarNotificacoesComoExibidas,
    notificacoes,
    mostraSinoNotificacoes,
    novaNotificacao,
    CHECKIFNOTIFICATION,
    CHECKIFNOTIFICATIONHOME,
    NOTIFICATIONSFOTOS,
    NOTIFICATIONSDESTAQUES,
    NOTIFICATIONSNOTICIAS,
    NOTIFICATIONSVIDEOS,
    NOTIFICATIONSFASES,
    NOTIFICATIONSAGENDAMENTOS,
    NOTIFICATIONSBOLETOS,
    NOTIFICATIONSBOLETOSVENCIDOS,
    NOTIFICATIONSPARCELAS,
    NOTIFICATIONSPARCELASVENCIDAS,
    NOTIFICATIONSVISTORIANAOCOMPARECEU,
    NOTIFICATIONSMANUTENCAOPERIODICA,
    NOTIFICATIONSPESQUISA,
    NOTIFICATIONS_CONTRATO_FINANCIAMENTO,
    setNovaNotificacao,
  } = useContext(ContextNotificacoes);

  const [desabilitarSinoNotificacoes, setDesabilitarSinoNotificacoes] =
    useState(false);

  useEffect(() => {
    if (notificacoes) CHECKIFNOTIFICATIONHOME(notificacoes.data);
    else CHECKIFNOTIFICATION();
  }, [notificacoes]);

  const marcarExibirNotificacoes = async () => {
    setDesabilitarSinoNotificacoes(true);
    let IdsNotificacaoAtualizacaoFotos = [];
    let IdsNotificacaoDestaques = [];
    let IdsNotificacaoNoticias = [];
    let IdsNotificacaoVideos = [];
    let IdsSalesForceNotificacaoSolicitacaoFase = [];
    let NotificacoesSolicitacaoAgendamento = [];
    let NotificacoesFinanceiroBoletosPendentes = [];
    let NotificacoesFinanceiroBoletosVencidos = [];
    let NotificacoesFinanceiroParcelasPendentes = [];
    let NotificacoesFinanceiroParcelasVencidas = [];
    let IdsSalesForceNotificacaoVistoriaNaoCompareceu = [];
    let IdsNotificacaoManutencaoPeriodica = [];
    let IdsNotificacaoAniversario = [];
    let IdsSalesForceNotificacoesSolicitacaoConcluida = [];
    let IdsNotificacaoContratoFinanciamento = [];
    IdsSalesForceNotificacoesSolicitacaoConcluida =
      retornaIdsNotificacoesPesquisa(NOTIFICATIONSPESQUISA);

    IdsNotificacaoAtualizacaoFotos =
      retornaIdsNotificacoesNaoExibidas(NOTIFICATIONSFOTOS);
    IdsNotificacaoDestaques = retornaIdsNotificacoesNaoExibidas(
      NOTIFICATIONSDESTAQUES
    );
    IdsNotificacaoNoticias = retornaIdsNotificacoesNaoExibidas(
      NOTIFICATIONSNOTICIAS
    );
    IdsNotificacaoVideos =
      retornaIdsNotificacoesNaoExibidas(NOTIFICATIONSVIDEOS);
    IdsSalesForceNotificacaoSolicitacaoFase =
      retornaIdsNotificacoesFaseNaoExibidas(NOTIFICATIONSFASES);

    NotificacoesSolicitacaoAgendamento = retornaAgendamentosNaoExibidas(
      NOTIFICATIONSAGENDAMENTOS
    );

    NotificacoesFinanceiroBoletosPendentes =
      retornaParcelasBoletosNaoExibidas(NOTIFICATIONSBOLETOS);

    NotificacoesFinanceiroBoletosVencidos = retornaParcelasBoletosNaoExibidas(
      NOTIFICATIONSBOLETOSVENCIDOS
    );

    NotificacoesFinanceiroParcelasPendentes = retornaParcelasBoletosNaoExibidas(
      NOTIFICATIONSPARCELAS
    );

    NotificacoesFinanceiroParcelasVencidas = retornaParcelasBoletosNaoExibidas(
      NOTIFICATIONSPARCELASVENCIDAS
    );

    IdsSalesForceNotificacaoVistoriaNaoCompareceu =
      retornaIdsNotificacoesFaseNaoExibidas(NOTIFICATIONSVISTORIANAOCOMPARECEU);

    IdsNotificacaoManutencaoPeriodica = retornaIdsNotificacoesNaoExibidas(
      NOTIFICATIONSMANUTENCAOPERIODICA
    );

    IdsNotificacaoContratoFinanciamento = retornaIdsNotificacoesNaoExibidas(
      NOTIFICATIONS_CONTRATO_FINANCIAMENTO
    );

    if (
      IdsNotificacaoAtualizacaoFotos.length ||
      IdsNotificacaoDestaques.length ||
      IdsNotificacaoNoticias.length ||
      IdsNotificacaoVideos.length ||
      IdsSalesForceNotificacaoSolicitacaoFase.length ||
      NotificacoesFinanceiroBoletosPendentes.length ||
      NotificacoesFinanceiroBoletosVencidos.length ||
      NotificacoesFinanceiroParcelasPendentes.length ||
      NotificacoesFinanceiroParcelasVencidas.length ||
      NotificacoesSolicitacaoAgendamento.length ||
      IdsSalesForceNotificacaoVistoriaNaoCompareceu.length ||
      IdsNotificacaoManutencaoPeriodica.length ||
      IdsSalesForceNotificacoesSolicitacaoConcluida.length ||
      IdsNotificacaoContratoFinanciamento.length
    )
      try {
        await marcarNotificacoesComoExibidas({
          IdsNotificacaoAtualizacaoFotos,
          IdsNotificacaoDestaques,
          IdsNotificacaoNoticias,
          IdsNotificacaoVideos,
          IdsNotificacaoAniversario,
          IdsSalesForceNotificacaoSolicitacaoFase,
          IdsSalesForceNotificacaoVistoriaNaoCompareceu,
          NotificacoesSolicitacaoAgendamento,
          NotificacoesFinanceiroBoletosPendentes,
          NotificacoesFinanceiroBoletosVencidos,
          NotificacoesFinanceiroParcelasPendentes,
          NotificacoesFinanceiroParcelasVencidas,
          IdsNotificacaoManutencaoPeriodica,
          IdsSalesForceNotificacoesSolicitacaoConcluida,
          IdsNotificacaoContratoFinanciamento,
        });
        await loadNotificacoes();
      } catch (error) {
        return [];
      }

    setDesabilitarSinoNotificacoes(false);
  };

  function retornaIdsNotificacoesNaoExibidas(arrayNotificacoes = []) {
    let tempIds = [];
    for (let notificacao of arrayNotificacoes) {
      if (notificacao?.Exibido === false || notificacao?.Is_Exibido === false)
        tempIds.push(notificacao.Id ?? notificacao.IdSalesForce);
    }
    return tempIds;
  }

  function retornaIdsNotificacoesPesquisa(arrayNotificacoes = []) {
    let tempIds = [];
    for (let notificacao of arrayNotificacoes) {
      if (notificacao?.Exibido === false || notificacao?.Is_Exibido === false)
        tempIds.push(notificacao.IdSalesForce ?? notificacao.Id);
    }
    return tempIds;
  }

  function retornaIdsNotificacoesFaseNaoExibidas(arrayNotificacoes) {
    let tempIds = [];
    for (let notificacao of arrayNotificacoes) {
      if (notificacao?.Exibido === false)
        tempIds.push(notificacao.IdSalesForce);
    }
    return tempIds;
  }

  function retornaParcelasBoletosNaoExibidas(arrayNotificacoes) {
    let tempParcelas = [];
    for (let p of arrayNotificacoes) {
      if (!p.Exibido)
        tempParcelas.push({
          ReceberIdReceber: p.IdReceber,
          DataVencimento: p.DtVencBoleto ?? p.DataVencimento,
          IdVenda: p.IdVenda,
          BancoBoleto: p.BancoBoleto,
          SeuNumero: p.SeuNumero,
          Exibido: new Date().toISOString(),
        });
    }
    return tempParcelas;
  }

  function retornaAgendamentosNaoExibidas(arrayAgendamentos) {
    let tempAgendamentos = [];

    for (let agendamento of arrayAgendamentos) {
      if (!agendamento.Exibido) {
        tempAgendamentos.push({
          IdSalesForce: agendamento?.Id,
          CaseNumber: agendamento?.CaseNumber,
          Grupo: agendamento?.Grupo,
          Subgrupo: agendamento?.Subgrupo,
          AssetId: agendamento?.AssetId,
          AssetName: agendamento?.Ativo,
          ExibidoDate: new Date().toISOString(),
          Subject: agendamento?.Subject,
          Status: agendamento?.Status,
          Fase: agendamento?.Fase,
          ServiceAppointmentId: agendamento?.CompromissoServico?.Id,
          FusoHorario: agendamento?.CompromissoServico?.FusoHorario,
          EarliestStartTime: agendamento?.CompromissoServico?.EarliestStartTime,
          SchedStartTime: agendamento?.CompromissoServico?.SchedStartTime,
          SchedEndTime: agendamento?.CompromissoServico?.SchedEndTime,
          Agente:
            agendamento?.CompromissoServico?.RecursoDisponibilizado
              ?.ServiceResource?.Name,
        });
      }
    }
    return tempAgendamentos;
  }

  if (novaNotificacao === null) return "";

  return (
    <div className="notificationsIcon">
      {!mostraSinoNotificacoes && (
        <button className="centralized" style={{ cursor: "unset" }}>
          <NotificationsBellIcon id="notifications-bell" />
        </button>
      )}
      {mostraSinoNotificacoes && (
        <>
          <button
            className="centralized"
            onClick={() => {
              setNotificationsModal(!notificationsModal);
              setNovaNotificacao(false);
              marcarExibirNotificacoes();
            }}
            id="btnVerModalNotificacoes"
            disabled={desabilitarSinoNotificacoes}
          >
            {novaNotificacao && (
              <span
                className="menu-top-left__inner__btns__agendamentos__qtd centralized"
                style={{
                  backgroundColor: "#BA122B",
                  textTransform: "lowercase",
                }}
              >
                i
              </span>
            )}

            <NotificationsBellIcon
              fill={primaryColor}
              id="notifications-bell"
            />

            <span
              className="centralized notificationsIcon__count"
              style={{ backgroundColor: primaryColor }}
            ></span>
          </button>
          {notificationsModal && (
            <div className="notificationsIcon__navigation">
              <Navigation />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NotificationsBell;
